import {
  DomainBranding,
  DomainBrandingSignedDocumentReference,
} from '@rygen/rygen-ui/model';

import {
  DocumentUploadUrlResponse,
  DomainPopulatorRequest,
  DomainPopulatorResponse,
} from '@/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'domain-populator';

export class DomainPopulatorController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async populate(
    request: DomainPopulatorRequest,
  ): Promise<DomainPopulatorResponse> {
    const response = await this.http.post('populate', request);
    return response.data;
  }

  async createDomainAndUsers(
    request: DomainPopulatorRequest,
  ): Promise<DomainPopulatorResponse> {
    const response = await this.http.post('create-domain-and-users', request);
    return response.data;
  }

  async continuePopulation(
    domainId: number,
    domainType: string,
  ): Promise<void> {
    await this.http.post(`continue-population/${domainId}/${domainType}`);
  }

  async getUploadUrl(
    domainId: number,
    documentReference: DomainBrandingSignedDocumentReference,
  ): Promise<DocumentUploadUrlResponse> {
    const response = await this.http.post(
      `get-upload-url/${domainId}`,
      documentReference,
    );

    return new DocumentUploadUrlResponse(response?.data);
  }

  async saveBranding(
    domainId: number,
    branding: DomainBranding,
  ): Promise<void> {
    await this.http.post(`save-branding/${domainId}`, branding);
  }
}
